import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import {
    getFormattedNumber,
    Sizes,
    Colours,
    MessagePropType,
} from '@ratehub/base-ui';


function CalculatorResultsBox({ resultValue, resultMessage, resultWarningMessage, ...otherProps }){
    const intl = useIntl();

    return (
        <ResultsBox
            data-disabled={resultValue === undefined && resultWarningMessage === undefined ? 'true' : undefined}
            $isCenterAligned={!!resultWarningMessage}
            {...otherProps}
        >
            <Choose>
                <When condition={resultWarningMessage == undefined || resultValue != undefined}>
                    <p className="label rh-text-l rh-mt-2 rh-mb-2 weight-medium">
                        {resultMessage}
                    </p>

                    <span
                        // data-name is used by QA's automated tests
                        data-name="results-box-value"
                        data-test-name="results-box-value"
                        className="result rh-mt-1_5 rh-mb-1_5 weight-medium"
                    >
                        {getFormattedNumber(resultValue, 'CAD0', intl)}
                    </span>
                </When>
                <When condition={resultWarningMessage != undefined || resultValue == undefined}>
                    <span
                        data-name="results-box-message"
                        className="result-message rh-text-m rh-mt-1_5 rh-mb-1_5"
                    >
                        {resultWarningMessage}
                    </span>
                </When>
            </Choose>
        </ResultsBox>
    );
}
CalculatorResultsBox.propTypes = {
    resultValue: PropTypes.number,
    resultMessage: MessagePropType, //FormattedMessage
    resultWarningMessage: MessagePropType, //FormattedMessage
};

CalculatorResultsBox.defaultProps = {
    resultValue: undefined,
    resultMessage: undefined,
    resultWarningMessage: undefined,
};

const ResultsBox = styled.section`
    border-radius: 6px;

    padding: ${Sizes.SPACING.ONE};
    margin: ${Sizes.SPACING.THREE} 0 ${Sizes.SPACING.TWO};
    background-color: ${Colours.BLUEBERRY_DARK};

    ${props => props.$isCenterAligned &&`
        text-align: center;
    `}

    > .label,
    > .result,
    > .result-message {
        color: ${Colours.COCONUT};
        margin: 0;
    }

    > .result {
        margin-top: ${Sizes.SPACING.HALF};
        font-size: ${Sizes.FONTS['3XL']};
    }

    &[data-disabled] {
        opacity: 0.4;
    }
`;

export default CalculatorResultsBox;
